import InvoicesDialog from './InvoicesDialog.container';

export default InvoicesDialog;
